import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { IntervalManager } from './app/_core/services/IntervalManager.service';
import { AppModule } from './app/app.module';
import { appVersion } from './environments/version';
import { environment } from '@environments/environment.stage';
import { globalTimerManager } from './app/_core/helper/global-timer-manager';

// Force version to be included in bundle - ensures cache busting on every build
console.log('[Cache Busting] Build:', appVersion.buildTimestamp);

// Initialize global tracking interceptors
globalTimerManager.init();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));

// window.setInterval = IntervalManager.setInterval.bind(IntervalManager);
// window.clearInterval = IntervalManager.clearInterval.bind(IntervalManager);

 